import { render, staticRenderFns } from "./AllocatePlanModel.vue?vue&type=template&id=e1865306"
import script from "./AllocatePlanModel.vue?vue&type=script&lang=js"
export * from "./AllocatePlanModel.vue?vue&type=script&lang=js"
import style0 from "./AllocatePlanModel.vue?vue&type=style&index=0&id=e1865306&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports